module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var c = require('Constants').default;
    ; __append("\r\n<div id=\"common-carousel\" class=\"carousel slide\" data-interval=\"false\">\r\n    <div class=\"carousel-inner\">\r\n        <div class=\"item active\">\r\n            ")
    ; 
                var prevItem;
                var itemCount = 0;
                _.forEach(items  , function(item) {
                    itemCount++;
                    if (!item.style) { item.style = ''; }
                    if (!item.textStyle) { item.textStyle = ''; }
                    if (itemCount === c.MAX_ITEMS_PER_SECTION_TOOLBAR) {
                        itemCount = 1;
                        
    ; __append("\r\n                        </div>\r\n                        <div class=\"item\">\r\n                            <div draggable=\"true\" id=\"")
    ; __append(escapeFn( prevItem.factoryKey ))
    ; __append("\" class=\"col-sm-1 nopadding factory-widget\">\r\n                                <div class=\"thumb ui-widget-header\">\r\n                                    <div class=\"row itemIcon\">\r\n                                    <i class=\"fa ")
    ; __append(escapeFn( prevItem.icon ))
    ; __append("\" style=\"")
    ; __append(escapeFn( prevItem.style ))
    ; __append("\"></i>\r\n                                    </div>\r\n                                    <div class=\"row itemName\">\r\n                                    <p style=\"")
    ; __append(escapeFn(prevItem.textStyle))
    ; __append("\">")
    ; __append(escapeFn( prevItem.name ))
    ; __append("</p>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                    ")
    ; 
                        itemCount++;
                    }
                    
    ; __append("\r\n                    <div draggable=\"true\" id=\"")
    ; __append(escapeFn( item.factoryKey ))
    ; __append("\" class=\"col-sm-1 nopadding factory-widget\">\r\n                        <div class=\"thumb ui-widget-header\">\r\n                          \r\n\r\n                                <div class=\"row itemIcon\">\r\n                                    <i class=\"fa ")
    ; __append(escapeFn( item.icon ))
    ; __append("\" style=\"")
    ; __append(escapeFn( item.style ))
    ; __append("\"></i>\r\n                                    </div>\r\n                                    <div class=\"row itemName\">\r\n                                        <p style=\"")
    ; __append(escapeFn(item.textStyle))
    ; __append("\">")
    ; __append(escapeFn( item.name ))
    ; __append("</p>\r\n                                    </div>\r\n                           \r\n                           \r\n\r\n                        </div>\r\n                    </div>\r\n\r\n                    ")
    ; 
                        prevItem = item;
                });
               
    ; __append("\r\n\r\n        </div>\r\n    </div> <!-- carousel-inner -->\r\n\r\n    <a class=\"left carousel-control\" href=\"#common-carousel\" role=\"button\" data-slide=\"prev\">\r\n        <span class=\"fa fa-angle-left\"></span>\r\n    </a>\r\n    <a class=\"right carousel-control\" href=\"#common-carousel\" role=\"button\" data-slide=\"next\">\r\n        <span class=\"fa fa-angle-right\"></span>\r\n    </a>\r\n</div><!-- thumbcarousel -->")
  }
  return __output;

}